import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { UserInformation } from "@models/user-information.model";
import { TemplateConstants } from "../constants/template-constants";

@Injectable({
  providedIn: 'root'
})

export class UserService {
  public readonly ENFORCE_PERMISSIONS: boolean = false;
  private canQuery: boolean = false;
  private canModify: boolean = false;
  private canUpload: boolean = false;
  private canAdmin: boolean = false;

  setUserPermissions(permissionResults: string[]) {

    if (!this.ENFORCE_PERMISSIONS) {
      this.canQuery = this.canModify = this.canUpload = true;
    }

    for (let i = 0; i < permissionResults.length; i++) {
      const entry = permissionResults[i];
      if (entry.localeCompare(TemplateConstants.QueryPermissionName, undefined, { sensitivity: 'base', caseFirst: 'lower' }) === 0) {
        this.canQuery = true;
      } else if (entry.localeCompare(TemplateConstants.CommandPermissionName, undefined, { sensitivity: 'base', caseFirst: 'lower' }) === 0) {
        this.canModify = true;
      } else if (entry.localeCompare(TemplateConstants.UploadPermissionName, undefined, { sensitivity: 'base', caseFirst: 'lower' }) === 0) {
        this.canUpload = true;
      } else if (entry.localeCompare(TemplateConstants.AdminPermissionName, undefined, { sensitivity: 'base', caseFirst: 'lower' }) === 0) {
        this.canAdmin = true;
      }
    }
  }
  public UserInformation: Observable<UserInformation | null>;

  private userInformation: BehaviorSubject<UserInformation | null> = new BehaviorSubject<UserInformation | null>(null);

  constructor() {
    this.UserInformation = this.userInformation.asObservable();
  }

  public setUserInformation(userInformation: UserInformation): void {
    this.userInformation.next(userInformation);
  }


  public hasQueryPermissions(): boolean {
    return this.canQuery;
  }

  public hasCommandPermissions(): boolean {
    return this.canModify;
  }

  public hasUploadPermissions(): boolean {
    return this.canUpload;
  }

  public hasAdminPermissions(): boolean {
    return this.canAdmin;
  }
}

